/* globals cpac, showResources, unselectProgram, selectProgram, $, $j, formSelectToggle, formSelect, my_isset, parceCourtGreed */

if (typeof cpac !== 'undefined') {
  cpac.fitness = cpac.fitness || {};
  cpac.fitness.privateLessonSelectDay = function( sender, baseUrl, index, group ) {
      if( sender.className=='selected_row') {
          unselectProgram( index, group );
      } else {
          selectProgram( index, group, '')
      }
  
      showResources( $('courtScheduleProperties'), baseUrl+'resource/court-schedule', 'courtsInfo');
  
      $('courtsInfo').style.display = '';
  }
  
  cpac.fitness.refreshGuestBills = function(playerGuestId) {
      var countGuests = $j('#rcAddedPlayers > .player-item-box-guest').size();
      var countMembers = $j('#rcAddedPlayers > .player-item-box').size() - countGuests;
  
      if (cpac.fitness.reserveForMember) {
          if (playerGuestId) {
              var newGuestBills = $j('#guest_bills').clone(true, true);
  
              newGuestBills.find('#guest_bill_guest_fee').attr('id', 'guest_bill_guest_fee_' + playerGuestId).attr('name', 'guest_bill_guest_fee[' + playerGuestId + ']');
  
              newGuestBills.find('#guest_bill_to_members-select-caption').attr('id', 'guest_bill_to_members_' + playerGuestId + '-select-caption');
              newGuestBills.find('#hidden_filter_guest_bill_to_members').attr('id', 'hidden_filter_guest_bill_to_members_' + playerGuestId);
              newGuestBills.find('#guest_bill_to_members').attr('id', 'guest_bill_to_members_' + playerGuestId).attr('name', 'guest_bill_to_members[' + playerGuestId + ']');
  
              newGuestBills.find('#guest_fee_to_members-select-caption').attr('id', 'guest_fee_to_members_' + playerGuestId + '-select-caption');
              newGuestBills.find('#hidden_filter_guest_fee_to_members').attr('id', 'hidden_filter_guest_fee_to_members_' + playerGuestId);
              newGuestBills.find('#guest_fee_to_members').attr('id', 'guest_fee_to_members_' + playerGuestId).attr('name', 'guest_fee_to_members[' + playerGuestId + ']');
  
              newGuestBills.find('#guest_bill_to_members_' + playerGuestId + '-select-caption').attr('onclick', '').click(
                  function() {
                      formSelectToggle('guest_bill_to_members_' + playerGuestId, 300);
                  }
              );
  
              newGuestBills.find('#hidden_filter_guest_bill_to_members_' + playerGuestId + ' a').each(
                  function() {
                      $j(this).attr('onclick', '').click(function(){
                          var optionValue = parseFloat($j(this).attr('id').split("_").last());
  
                          formSelect.selectOption($j(this)[0], $j(this)[0].parentNode.parentNode, 'guest_bill_to_members_' + playerGuestId, optionValue, 1);
                      })
                  }
              );
  
              newGuestBills.find('#guest_fee_to_members_' + playerGuestId + '-select-caption').attr('onclick', '').click(
                  function() {
                      formSelectToggle('guest_fee_to_members_' + playerGuestId, 300);
                  }
              );
  
              newGuestBills.find('#hidden_filter_guest_fee_to_members_' + playerGuestId + ' a').each(
                  function() {
                      $j(this).attr('onclick', '').click(function(){
                          var optionValue = parseFloat($j(this).attr('id').split("_").last());
  
                          formSelect.selectOption($j(this)[0], $j(this)[0].parentNode.parentNode, 'guest_fee_to_members_' + playerGuestId, optionValue, 1);
                      })
                  }
              );
  
              newGuestBills.attr('id', '');
              newGuestBills.show().appendTo($j('#rcPlayer' + playerGuestId));
  
              if (cpac.fitness.playerOptions != undefined) {
                  if (cpac.fitness.playerOptions.chargeGuestFee != undefined) {
                      var chargeGuestFeeValue = undefined;
  
                      if (cpac.fitness.playerOptions.chargeGuestFee.players != undefined && cpac.fitness.playerOptions.chargeGuestFee.players[playerGuestId] != undefined) {
                          chargeGuestFeeValue = cpac.tennis.playerOptions.chargeGuestFee.players[playerGuestId];
                      } else if (cpac.fitness.playerOptions.chargeGuestFee['default'] != undefined) {
                          chargeGuestFeeValue = cpac.tennis.playerOptions.chargeGuestFee['default'];
                      }
  
                      var chargeFeeButton = newGuestBills.find('.charge-guest-fee');
  
                      if (chargeGuestFeeValue != 0) {
                          if (chargeFeeButton.hasClass('checkbox-off')) {
                              chargeFeeButton.click();
                              newGuestBills.find('.guest-fee-to-smb-container').show();
                          }
                      } else {
                          if (chargeFeeButton.hasClass('checkbox-on')) {
                              chargeFeeButton.click();
                              newGuestBills.find('.guest-fee-to-smb-container').hide();
                          }
                      }
                  }
  
                  if (cpac.fitness.playerOptions.billGuestFee != undefined) {
                      var billGuestFeeValue = undefined;
  
                      if (cpac.fitness.playerOptions.billGuestFee.players != undefined && cpac.fitness.playerOptions.billGuestFee.players[playerGuestId] != undefined) {
                          billGuestFeeValue = cpac.tennis.playerOptions.billGuestFee.players[playerGuestId];
                      } else if (cpac.fitness.playerOptions.billGuestFee['default'] != undefined) {
                          billGuestFeeValue = cpac.tennis.playerOptions.billGuestFee['default'];
                      }
  
                      if (billGuestFeeValue != undefined) {
                          newGuestBills.find('#hidden_filter_guest_fee_to_members_' + playerGuestId).find('#guest_fee_to_members_row_' + billGuestFeeValue).click();
                      }
                  }
  
                  if (cpac.fitness.playerOptions.billGuestCharge != undefined) {
                      var billGuestChargeValue = undefined;
  
                      if (cpac.fitness.playerOptions.billGuestCharge.players != undefined && cpac.fitness.playerOptions.billGuestCharge.players[playerGuestId] != undefined) {
                          billGuestChargeValue = cpac.tennis.playerOptions.billGuestCharge.players[playerGuestId];
                      } else if (cpac.fitness.playerOptions.billGuestCharge['default'] != undefined) {
                          billGuestChargeValue = cpac.fitness.playerOptions.billGuestCharge['default'];
                      }
  
                      if (billGuestChargeValue != undefined) {
                          newGuestBills.find('#hidden_filter_guest_bill_to_members_' + playerGuestId).find('#guest_bill_to_members_row_' + billGuestChargeValue).click();
                      }
                  }
              }
          }
      } else {
          $j('#guest_bills').show();
          $j('#guest_bills').find('.checkbox-off, .checkbox-on').hide();
          $j('#guest_bills').find('#guest_bill_to_members-select-caption, #guest_fee_to_members-select-caption').hide();
  
          if (countGuests >= 1) {
              $j('#guest_bills').find('.checkbox-off, .checkbox-on').show();
          }
          if (countMembers >= 1) {
              if (countGuests >= 1) {
                  $j('#guest_bills').find('#guest_bill_to_members-select-caption, #guest_fee_to_members-select-caption').show();
              }
          }
      }
  
      var primaryReplacement = ' (Primary)';
      if (cpac.fitness.reserveForMember) {
          primaryReplacement = ' (Host)';
      }
  
      $j('#rcAddedPlayers > .player-item-box a.fb-user-box-title').each(function() {
          $j(this).html($j(this).html().replace(primaryReplacement, ''));
      });
      $j('#rcAddedPlayers > .player-item-box a.fb-user-box-title:first').each(function() {
          $j(this).html($j(this).html() + primaryReplacement);
      });
  
      if (!($j('#rcAddedPlayers > .player-item-box').length)) {
          $j('#fakeUserName')
              .caUserPicker('clearItem')
              .caUserPicker('option', 'placeholder', cpac.fitness.placeholderForPrimary)
              .blur();
      }
  }
  
  cpac.fitness.addPlayer = function( id, name, price, priceType, replace, isGuest, cantChangePlayers ) {try {
      if( ! id ) {
          id = new String($('rcUserId').value);
      }
      var newDivId = 'rcPlayer' + id;
  
      // check if such player already exists
      if (id > 0 && $(newDivId) == null)
      {
          if( ! price ) {
              price = $('rcUserPrice').value;
          }
  
          if( price == '-default-' ) {
              //
          } else if( ! isNaN( price )) {
              //
          } else {
              return false;
          }
  
          if ($('rcHiddenPlayerList').value == '')
          {
              $('rcHiddenPlayerList').value = id;
              if($('rcNone')) {
                  $('rcAddedPlayers').removeChild($('rcNone'));
              }
          } else {
              $('rcHiddenPlayerList').value += ',' + id;
          }
  
          if( ! priceType ) {
              priceType = $('price_type').value;
          }
          var priceTypeValue = priceType;
          switch( priceType ) {
              case 'per_hour':priceType = 'per hour';break;
              case 'full' :priceType = 'per lesson/person';break;
          }
  
          if( ! name ) {
              name = $('rcUserName').value;
          }
  
          if( cantChangePlayers === undefined && $j('#cantChangePlayers').length == 1 ) {
              cantChangePlayers = !!parseInt($j('#cantChangePlayers').val());
          }

          var playerString = document.createElement("div");
          playerString.className = 'player-item-box';
          playerString.id = newDivId;
          var echo = '';
  
          echo += '<div class="fb-user-box">';
          if( !cantChangePlayers ) {
              echo += '<a onclick="cpac.tennis.removePlayer('+id+');" href="javascript:void(0)" class="fb-user-box-close"></a>';
          }
          echo += '<a href="/user/edit/?id='+id+'" class="fb-user-box-title">'+name+'</a>';
          echo += '</div>';
  
          // user package 
          var upackage = $j('#upackage_' + id);
          if (upackage.length && $j('#upackage_' + id).data('isLoaded') != true) {
              cantChangePlayers = true;
              $j('#upackage_' + id).data('isLoaded', true);
              echo += '<div class="package_label">Package</div>';
          }
          
          if( cantChangePlayers || window.cpacTennisPlayerHidePrice ) {
              echo += price == '-default-' ? '<span> </span>' : ' <span>($'+ price+' '+ priceType +')</span> ';
              echo += '<input type="hidden" id="price_'+id+'" name="price_'+id+'" value="'+price+'" />';
              echo += '<input type="hidden" id="price_type_'+id+'" name="price_type_'+id+'" value="'+priceTypeValue+'" />';
          } else {
              echo += '<div class="player-price-type">';
              echo += cpac.formSelect({
                   name: 'price_type_'+id
                  ,options: {'per_hour': 'Per Hour', 'full': 'Per Lesson/Person'}
                  ,'default': priceTypeValue
                  ,'className': 'report-select'
              });
              echo += '</div>';
  
              echo += '<div class="player-price">$&nbsp;';
              echo += '<input class="field thin-border" type="text" id="price_'+id+'" name="price_'+id+'" value="'+price+'" onclick="'+"if(this.value=='-default-')this.value=''"+'" onchange="'+"if(this.value=='')this.value='-default-'"+'" onblur="'+"if(this.value=='')this.value='-default-'"+'" class="price"/>';
              echo += '</div>';
          }
          
          playerString.innerHTML = echo;
  
          if( ! replace ) {
              $('rcAddedPlayers').appendChild(playerString);
              $('rcUserName').value = '';
              $('rcUserId').value = '';
              $('rcUserPrice').value = '-default-';
              if( $('rcUserSearchBox')) {
                  $('rcUserSearchBox').hide();
              }
          } else {
              replace.insert({after: playerString});
          }
  
          if (!my_isset(isGuest)) {
              isGuest = $('rcUserIsGuest') ? $('rcUserIsGuest').value : 0;
          }
          if (isGuest == '1') {
              $j('#' + newDivId).addClass('player-item-box-guest');
          }
  
          this.refreshGuestBills();
  
          var offsite_value = $j('[name="offsite[street_address]"]').val();
          if ((offsite_value == 'Street Address' || $j('.player-item-box').length == 1) && $j('#select_component_id').val() == 'offsite') {
              showResources( '', '/offsite/getaddress', 'cell-5','','user='+id);
          }
          return true;
      } else if (!id || id == '0' || id == '' ) {
          alert('Please enter valid player name');
      } else {
          return false;
      }
  } catch(e){cpac.error(e)}}
  
  cpac.fitness.editPlayer = function(id) {try {
      var playerItem = $('rcPlayer'+id);
      if( playerItem ) {
          var playerName      = playerItem.down('.player-name').innerHTML;
          var playerPrice     = playerItem.down('[name="price_'+id+'"]').value;
          var playerPriceType = playerItem.down('[name="price_type_'+id+'"]').value;
  
          var playerString = document.createElement("div");
          playerString.className = 'player-item-edit';
          playerString.id = 'rcEditPlayer'+id;
          var echo = '';
          echo += '<div class="player-name">Member name&nbsp;';
          echo += '<input id="rcUserEditName'+id+'" type="text" class="field" value="'+playerName+'" onFocus="cpac.tennis.nameFieldOnFocus('+"'rcUserEditName"+id+"', 'rcUserEditId"+id+"', 'rcUserEditIsGuest"+id+"', null, 1, null, null, 1);"+'" />';
          echo += '<input id="rcUserEditIsGuest'+id+'" type="hidden" value="0" />';
          echo += '</div>';
          if( window.cpacTennisPlayerHidePrice ) {
              echo += '<input type="hidden" id="rcUserEditPrice'+id+'" value="'+playerPrice+'" />';
              echo += '<input type="hidden" id="rcUserEditPriceType'+id+'" value="'+playerPriceType+'" />';
          } else {
              echo += '<div class="player-price">$&nbsp;';
              echo += '<input class="field" type="text" id="rcUserEditPrice'+id+'" value="'+playerPrice+'" onclick="'+"if(this.value=='-default-')this.value=''"+'" onchange="'+"if(this.value=='')this.value='-default-'"+'" onblur="'+"if(this.value=='')this.value='-default-'"+'" class="price"/>';
              echo += '</div>';
              echo += '<div class="player-price-type">';
              echo += cpac.formSelect({
                   name: 'rcUserEditPriceType'+id
                  ,options: {per_hour: 'per hour', full: 'per lesson/person'}
                  ,'default': playerPriceType
              });
              echo += '</div>';
          }
          echo += '<div class="player-save-changes">';
          echo += '<button class="button nicebutton" type="button" value="Save" onclick="cpac.tennis.saveEditPlayer('+id+');">Save</button>';
          echo += '</div>';
          echo += '<input type="hidden" id="rcUserEditId'+id+'" value="'+id+'">';
  
          playerString.innerHTML = echo;
          playerItem.hide();
          playerItem.insert({after: playerString});
      }
  }
  catch(e){cpac.error(e)}}
  
  cpac.fitness.updateTrainerSchedule = function(sender) {
      var baseUrl = '/';
      var url = baseUrl;
  
      if( sender.id == 'pro-scheduling-button' ) {
          cpac.tennis.toggleReserveButtons(sender.id);
          $(sender).toggleClassName('active');
          if( $(sender).hasClassName('active') )
          {
              url += 'fitness/trainer-schedule'+( $('date') ? '?date='+$('date').value : '' );
              showResources( $('courtScheduleProperties'), url, 'court-properties-container');
          } else {
              url += 'fitness'+( $('date') ? '?date='+$('date').value : '' );
              showResources( null, url, 'court-properties-container', function(){
                  showResources($('courtScheduleProperties'), baseUrl+'resource/court-schedule', 'courtsInfo');
              });
          }
          return;
      }
  
      url += 'fitness/trainer-schedule?onlygrid=true';
  
      if( sender.id == 'add_user_id' ) {
          url += '&staff_id='+sender.value;
      }
  
      if( sender.id == 'date' ) {
          url += '&date_change=1';
      }
  
      if( sender.id == 'save' ) {
          url += '&save=1';
      }
  
      if( sender.id == 'copy-from-date-button' ) {
          url += '&date_change=1&copy-from='+$('copy-from-date').value;
      }
  
      if( $('courtScheduleProperties') )
      {
          parceCourtGreed( $('courtScheduleProperties').multiselectdata, true );
          $('courtScheduleProperties').trainers.value = $j('#add_user_list').val();
  
          showResources( $('courtScheduleProperties'), url, 'courtsInfo');
      }
  }
}